// extracted by mini-css-extract-plugin
module.exports = {"content":"Errors__content___2YUpF","icon":"Errors__icon___7paF5","msg":"Errors__msg___2fm3J","btn":"Errors__btn___1BxLb"};